<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <g fill="none"><rect width="31" height="20" rx="2" fill="#162056"/><g fill="#FFF"><path d="M27 7.3C27 6 26 4.9 24.7 4.9L24.7 4.9 16.3 4.9 16.3 9.8 24.7 9.8 24.7 9.8C26 9.8 27 8.7 27 7.3L27 7.3Z"/><path d="M27 12.5C27 11.2 26 10.1 24.7 10.1L24.7 10.1 16.3 10.1 16.3 15 24.7 15 24.7 15C26 15 27 13.9 27 12.5Z"/><path d="M9.9 10.1L9.9 9.8 16.1 9.8 16.1 9.4C16.1 6.9 14.2 4.9 11.9 4.9L7.9 4.9C5.6 4.9 3.7 6.9 3.7 9.4L3.7 10.5C3.7 13 5.6 15 7.9 15L11.9 15C14.2 15 16.1 13 16.1 10.5L16.1 10.1 9.9 10.1 9.9 10.1Z"/></g></g>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'CB',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyCb',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 31 20',
    },
  },
};
</script>

<style scoped>
  
</style>